// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scforh-intro {
  --scforh-ink: #1b2a32;
  --scforh-muted: #4a5d66;
  --scforh-line: rgba(27, 42, 50, 0.08);
  --scforh-wash: linear-gradient(165deg, #f4fbf8 0%, #eef6fb 52%, #f7f3ee 100%);
  --scforh-physical: #c45c3a;
  --scforh-mental: #5b4db3;
  --scforh-social: #1d8a78;
  text-align: left;
  border-radius: 18px;
  padding: 1.15rem 1.2rem 1.2rem;
  background: var(--scforh-wash);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.7) inset,
    0 10px 28px -12px rgba(27, 42, 50, 0.18);
  border: 1px solid rgba(29, 138, 120, 0.12);
  animation: scforh-intro-in 0.45s cubic-bezier(0.25, 1, 0.5, 1);
}

@keyframes scforh-intro-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .scforh-intro {
    animation: none;
  }
}

.scforh-intro--dark {
  --scforh-ink: #f4f7f8;
  --scforh-muted: rgba(226, 232, 240, 0.78);
  --scforh-line: rgba(255, 255, 255, 0.08);
  --scforh-wash: linear-gradient(165deg, rgba(29, 138, 120, 0.16) 0%, rgba(91, 77, 179, 0.12) 100%);
  background: var(--scforh-wash);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: none;
}

.scforh-intro__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--scforh-social);
}

.scforh-intro--dark .scforh-intro__eyebrow {
  color: #7ee0ce;
}

.scforh-intro__title {
  margin: 0 0 0.55rem;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--scforh-ink);
}

.scforh-intro--compact .scforh-intro__title {
  font-size: 1.05rem;
}

.scforh-intro__body {
  margin: 0 0 0.9rem;
  font-size: 0.92rem;
  line-height: 1.5;
  color: var(--scforh-muted);
}

.scforh-intro--compact .scforh-intro__body {
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
}

.scforh-intro__tt {
  margin: 0 0 0.9rem;
  font-size: 0.92rem;
  line-height: 1.5;
  color: var(--scforh-ink);
  font-weight: 600;
}

.scforh-intro--compact .scforh-intro__tt {
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
}

.scforh-intro__dims {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  margin: 0 0 0.95rem;
  padding: 0;
}

.scforh-intro__dim {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 2.35rem;
  padding: 0.35rem 0.45rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  background: rgba(255, 255, 255, 0.7);
  color: var(--scforh-ink);
}

.scforh-intro--dark .scforh-intro__dim {
  background: rgba(15, 23, 42, 0.35);
  color: var(--scforh-ink);
}

.scforh-intro__dim-mark {
  width: 0.48rem;
  height: 0.48rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.scforh-intro__dim--physical .scforh-intro__dim-mark {
  background: var(--scforh-physical);
  box-shadow: 0 0 0 4px rgba(196, 92, 58, 0.16);
}

.scforh-intro__dim--mental .scforh-intro__dim-mark {
  background: var(--scforh-mental);
  box-shadow: 0 0 0 4px rgba(91, 77, 179, 0.16);
}

.scforh-intro__dim--social .scforh-intro__dim-mark {
  background: var(--scforh-social);
  box-shadow: 0 0 0 4px rgba(29, 138, 120, 0.16);
}

.scforh-intro__name {
  margin: 0 0 0.45rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--scforh-line);
  font-size: 0.9rem;
  line-height: 1.45;
  font-weight: 600;
  color: var(--scforh-ink);
}

.scforh-intro--compact .scforh-intro__name {
  font-size: 0.82rem;
  font-weight: 600;
}

.scforh-intro__name strong {
  font-weight: 800;
}

.scforh-intro__research {
  margin: 0;
  font-size: 0.72rem;
  line-height: 1.4;
  letter-spacing: 0.01em;
  color: var(--scforh-muted);
}

.scforh-intro__more {
  margin: 0.5rem 0 0;
  font-size: 0.78rem;
  line-height: 1.4;
  color: var(--scforh-muted);
}

.scforh-intro__more-link {
  color: var(--scforh-social);
  font-weight: 650;
  text-decoration: none;
  border-bottom: 1px solid color-mix(in srgb, var(--scforh-social) 42%, transparent);
  transition: border-color 0.18s ease, color 0.18s ease;
}

.scforh-intro__more-link:hover,
.scforh-intro__more-link:focus-visible {
  color: var(--scforh-ink);
  border-bottom-color: currentColor;
}

.scforh-intro--dark .scforh-intro__more-link {
  color: #7ee0ce;
}

.scforh-intro--dark .scforh-intro__more-link:hover,
.scforh-intro--dark .scforh-intro__more-link:focus-visible {
  color: #f4f7f8;
}

@media (max-width: 520px) {
  .scforh-intro__dims {
    grid-template-columns: 1fr;
  }

  .scforh-intro__dim {
    justify-content: flex-start;
    padding-left: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScforhApproachIntro.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;EACrC,6EAA6E;EAC7E,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B;;4CAE0C;EAC1C,0CAA0C;EAC1C,8DAA8D;AAChE;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,wCAAwC;EACxC,iGAAiG;EACjG,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,kFAAkF;EAClF,qDAAqD;AACvD;;AAEA;;EAEE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;AACF","sourcesContent":[".scforh-intro {\n  --scforh-ink: #1b2a32;\n  --scforh-muted: #4a5d66;\n  --scforh-line: rgba(27, 42, 50, 0.08);\n  --scforh-wash: linear-gradient(165deg, #f4fbf8 0%, #eef6fb 52%, #f7f3ee 100%);\n  --scforh-physical: #c45c3a;\n  --scforh-mental: #5b4db3;\n  --scforh-social: #1d8a78;\n  text-align: left;\n  border-radius: 18px;\n  padding: 1.15rem 1.2rem 1.2rem;\n  background: var(--scforh-wash);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.7) inset,\n    0 10px 28px -12px rgba(27, 42, 50, 0.18);\n  border: 1px solid rgba(29, 138, 120, 0.12);\n  animation: scforh-intro-in 0.45s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n@keyframes scforh-intro-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .scforh-intro {\n    animation: none;\n  }\n}\n\n.scforh-intro--dark {\n  --scforh-ink: #f4f7f8;\n  --scforh-muted: rgba(226, 232, 240, 0.78);\n  --scforh-line: rgba(255, 255, 255, 0.08);\n  --scforh-wash: linear-gradient(165deg, rgba(29, 138, 120, 0.16) 0%, rgba(91, 77, 179, 0.12) 100%);\n  background: var(--scforh-wash);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: none;\n}\n\n.scforh-intro__eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--scforh-social);\n}\n\n.scforh-intro--dark .scforh-intro__eyebrow {\n  color: #7ee0ce;\n}\n\n.scforh-intro__title {\n  margin: 0 0 0.55rem;\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--scforh-ink);\n}\n\n.scforh-intro--compact .scforh-intro__title {\n  font-size: 1.05rem;\n}\n\n.scforh-intro__body {\n  margin: 0 0 0.9rem;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: var(--scforh-muted);\n}\n\n.scforh-intro--compact .scforh-intro__body {\n  font-size: 0.85rem;\n  margin-bottom: 0.75rem;\n}\n\n.scforh-intro__tt {\n  margin: 0 0 0.9rem;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: var(--scforh-ink);\n  font-weight: 600;\n}\n\n.scforh-intro--compact .scforh-intro__tt {\n  font-size: 0.85rem;\n  margin-bottom: 0.75rem;\n}\n\n.scforh-intro__dims {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.5rem;\n  margin: 0 0 0.95rem;\n  padding: 0;\n}\n\n.scforh-intro__dim {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 2.35rem;\n  padding: 0.35rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--scforh-ink);\n}\n\n.scforh-intro--dark .scforh-intro__dim {\n  background: rgba(15, 23, 42, 0.35);\n  color: var(--scforh-ink);\n}\n\n.scforh-intro__dim-mark {\n  width: 0.48rem;\n  height: 0.48rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.scforh-intro__dim--physical .scforh-intro__dim-mark {\n  background: var(--scforh-physical);\n  box-shadow: 0 0 0 4px rgba(196, 92, 58, 0.16);\n}\n\n.scforh-intro__dim--mental .scforh-intro__dim-mark {\n  background: var(--scforh-mental);\n  box-shadow: 0 0 0 4px rgba(91, 77, 179, 0.16);\n}\n\n.scforh-intro__dim--social .scforh-intro__dim-mark {\n  background: var(--scforh-social);\n  box-shadow: 0 0 0 4px rgba(29, 138, 120, 0.16);\n}\n\n.scforh-intro__name {\n  margin: 0 0 0.45rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--scforh-line);\n  font-size: 0.9rem;\n  line-height: 1.45;\n  font-weight: 600;\n  color: var(--scforh-ink);\n}\n\n.scforh-intro--compact .scforh-intro__name {\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.scforh-intro__name strong {\n  font-weight: 800;\n}\n\n.scforh-intro__research {\n  margin: 0;\n  font-size: 0.72rem;\n  line-height: 1.4;\n  letter-spacing: 0.01em;\n  color: var(--scforh-muted);\n}\n\n.scforh-intro__more {\n  margin: 0.5rem 0 0;\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: var(--scforh-muted);\n}\n\n.scforh-intro__more-link {\n  color: var(--scforh-social);\n  font-weight: 650;\n  text-decoration: none;\n  border-bottom: 1px solid color-mix(in srgb, var(--scforh-social) 42%, transparent);\n  transition: border-color 0.18s ease, color 0.18s ease;\n}\n\n.scforh-intro__more-link:hover,\n.scforh-intro__more-link:focus-visible {\n  color: var(--scforh-ink);\n  border-bottom-color: currentColor;\n}\n\n.scforh-intro--dark .scforh-intro__more-link {\n  color: #7ee0ce;\n}\n\n.scforh-intro--dark .scforh-intro__more-link:hover,\n.scforh-intro--dark .scforh-intro__more-link:focus-visible {\n  color: #f4f7f8;\n}\n\n@media (max-width: 520px) {\n  .scforh-intro__dims {\n    grid-template-columns: 1fr;\n  }\n\n  .scforh-intro__dim {\n    justify-content: flex-start;\n    padding-left: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
